// import the required animation functions from the angular animations module
import { trigger, state, animate, transition, style, AnimationTriggerMetadata } from '@angular/animations';

export const navUserItemEnter =
trigger('navUserItemEnter', [
    transition(':enter', [
        style({ 'max-height': 0, 'padding-top': '0px', 'padding-bottom': '0px', overflow: 'hidden' }),
        animate('0.5s ease-out', style({ 'max-height': 190, 'padding-top': '33px', 'padding-bottom': '33px', overflow: 'hidden' }))
    ]),
    transition(':leave', [
        style({ 'max-height': 190, 'padding-top': '33px', 'padding-bottom': '33px', overflow: 'hidden' }),
        animate('0.5s ease-out', style({ 'max-height': 0, 'padding-top': '0px', 'padding-bottom': '0px', overflow: 'hidden' }))
    ])
]);
